<bento-alert [items]="alerts">
</bento-alert>

<div #netclientHeading>
  <h1 class="learn-more-heading">{{'onvio.setup.migrations.netclient.title' | translate }}</h1>
</div>
<div #trAuthContainer>
	<ng-template #trAuthContent let-c="close" let-d="dismiss">
		<button type="button" class="close" aria-label="Close" (click)="d()">
			<i class="bento-icon-close-x" aria-hidden="true"></i>
		</button>
		<div class="login-tr-auth">
		</div>
	</ng-template>
</div>

<ng-template #transferBoxSettings>
	<div ngbDropdown class="ml-auto">
		<button
				class="btn btn-outline-primary btn-icon btn-toggle dropdown-toggle"
				ngbDropdownToggle
				placement="bottom"
				[aria-label]="'onvio.setup.migrations.netclient.showHideColumns' | translate"
				[ngbTooltip]="'onvio.setup.migrations.netclient.showHideColumns' | translate">
			<i aria-hidden="true" class="bento-icon-cog"></i>
			<i aria-hidden="true" class="bento-icon-caret-down-filled"></i>
		</button>
		<div ngbDropdownMenu class="dropdown-menu grid-dropdown">
			<fieldset>
				<legend class="p-2"> {{'onvio.setup.migrations.netclient.selectColumns' | translate }} </legend>
				<ul class="group-list">
					<li class="dropdown-item" *ngFor="let item of gridOptions">
						<label class="grid-toolbar-checkbox-label">
							<bento-checkbox [(ngModel)]="item.visible" [attr.id]="'checkbox-column-' + item.header">
							</bento-checkbox>
							{{item.header}}
						</label>
					</li>
				</ul>
			</fieldset>
		</div>
	</div>
</ng-template>

<div *ngIf="showTransferBox">
  <div class="client-loading" *ngIf="!dataLoaded">
    <p *ngIf="!alerts.length && !dataLoaded">{{'onvio.setup.migrations.netfirm.loading.client.details' | translate}}</p>
    <div [bentoBusyLoader]="!dataLoaded">
    </div>
  </div>
  <div [bentoBusyLoader]="showBusyloaderMigrateSelected"></div>
  <div *ngIf="dataLoaded" [ngClass]="{'wait-for-response': showBusyloaderMigrateSelected === true}">
	<h2>{{ 'onvio.setup.migrations.netfirm.portalsmigrate' | translate }}</h2>
	<div class="d-flex mb-2">
		<span [innerHTML]="'onvio.setup.migrations.netfirm.portalcount' | translate: {'count': availablePortals.length}"></span>
		<ng-container *ngTemplateOutlet="transferBoxSettings"></ng-container>
	</div>
    <bento-transferbox class="netclient-user-list portals-to-migrate-content" data-qe-id="migration-dashboard-choose-portals-transferbox"
      #transferbox
      [boxOneItemSource]="availablePortals"
      [boxTwoItemSource]="selectedPortals"
      [boxOneTitle]="'Available Portals'"
      [boxTwoTitle]="'Selected Portals'"
      [columnDefinitions]="gridOptions"
      [hidePagination]="hidePagination"
      [hideFilters]="hideFilters"
      [height]="gridHeight"
      [columnKey]="'id'"
      (transfer)="onTransfer($event)"
    >
    </bento-transferbox>
    <div [ngClass]="{'portals-to-migrate-footer': makeFooterSticky === true}" #migrationFooter>
			<button data-qe-id="migration-dashboard-choose-portals-migrate-button" class="btn btn-primary" [disabled]="!selectedPortals.length" (click)="migrateSelected()">
				{{'onvio.setup.migrations.netfirm.tb.migrate' | translate }}
			</button>
			&nbsp;
      <button data-qe-id="migration-dashboard-choose-portals-cancel-button" class="btn btn-outline-primary" (click)="hideTransferBox()">
        {{'onvio.setup.migrations.netfirm.tb.cancel' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- TODO: Refactor this to use the migration container component instead of being its own implementation -->
<div class="migration-container-status" *ngIf="!showTransferBox">
	<div class="migration-status-per-product">
    <app-inprogress
            [migrationSource]="migrationSource"
			[productName]="productInfo.productName"
      [customTemplate]="portalSelection"
      (updateMigrationResult)="updateInProgressMigrationStatus($event)">
    </app-inprogress>

    <app-completed class="completed-container"
                   [migrationSource]="migrationSource"
			[showClientRegistrationLink]="true"
		  [migrationDetailsInfoTitle]='"Migrated Portals"'
                   (newCompletedMigrationWasAdded)="showLastCompletedMigration($event)">
    </app-completed>
  </div>
</div>

<ng-template #portalSelection>
	<div class="d-flex flex-column align-items-center p-3 my-2 panel-border"
		 [ngClass]="{'wait-for-response': hasServerError === true}"
		 [bentoBusyLoader]="showMigrationResultsBusyLoader">
		<h2 class="m-0 mt-1">{{ 'onvio.setup.migrations.netfirm.getStated' | translate }}</h2>
		<div class="d-flex flex-column align-items-start orange-border p-2 mt-2">
			<span>{{ 'onvio.setup.migrations.netfirm.needMoreInformation' | translate }}</span>
			<ul>
				<li>
					<span>{{ 'onvio.setup.migrations.netfirm.statusOfYourMigration' | translate }} </span>
					<a [href]="PREPARE_FOR_MIGRATION_LINK"
					   data-qe-id="migration-dashboard-netfirm-prepare-for-migration-link"
					   target="_blank">{{ 'onvio.setup.migrations.netfirm.prepareForMigrationToOnvio' | translate }}</a>
				</li>
				<li>
					<span>{{ 'onvio.setup.migrations.netfirm.clientDataThatMigrates' | translate }} </span>
					<a [href]="NETCLIENT_TO_ONVIO_LINK"
					   data-qe-id="migration-dashboard-netfirm-netclient-to-onvio-link"
					   target="_blank">{{ 'onvio.setup.migrations.netfirm.migrateNetClientCsPortalsToOnvioClientCenter' | translate }}</a>
				</li>
			</ul>
		</div>
		<button data-qe-id="migration-dashboard-netfirm-chooseportals-button" type="button" class="btn btn-primary mt-3 wide-button" (click)="choosePortals(trAuthContent)">
			{{'onvio.setup.migrations.netfirm.chooseportals' | translate}}
		</button>
	</div>
	<bento-alert [inline]="true" [items]="inlineAlerts"></bento-alert>
</ng-template>


<ng-template #completedMigrationBanner let-options="options" let-index="index">
	<div class="d-flex align-items-center">
		<p class="text-left">
			{{'onvio.setup.migrations.netfirm.status.completed.banner.migrationStarted' | translate: {date: options.data.date, time: options.data.time} }}
		</p>
		<button class = "btn btn-link"
				attr.data-qe-id="migration-dashboard-netclient-send-registrations-link"
			type="button"
			(click)="sendRegistrations(index)">
			<ins>{{'onvio.setup.migrations.netfirm.status.completed.banner.sendRegistrations' | translate}}</ins>
	</button>
	</div>
</ng-template>
